import Swiper from 'swiper'

((window, document) => {
    const container = document.querySelector('.js--events-carousel')

    if (!container)
        return

    /**
    * Get Closest Element
    * @param  {HTML Object} element
    * @param  {String} selector
    * @return {HTML Object|null}
    */
    function closest (element, selector) {
        let node = element

        while (node && node.nodeType === 1) {
            const matches = node.matches
                || node.msMatchesSelector
                || node.webkitMatchesSelector

            if (matches && matches.call(node, selector))
                return node

            node = node.parentElement
        }

        return null
    }

    // Cards are fixed-width and bleed off the right edge, so the count per
    // view comes from the viewport rather than a breakpoint table
    const slider = new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 5,
        watchOverflow: true,
        navigation: {
            prevEl: document.querySelector('.js--events-carousel-prev'),
            nextEl: document.querySelector('.js--events-carousel-next')
        },
        scrollbar: {
            el: document.querySelector('.js--events-carousel-progress'),
            draggable: true
        }
    })

    // Focusing a card scrolls the hidden viewport out of sync with Swiper's
    // transform
    container
        .addEventListener('scroll', () => {
            if (container.scrollLeft)
                container.scrollLeft = 0
        })

    container
        .addEventListener('focusin', (event) => {
            const slide = closest(event.target, '.swiper-slide')

            if (!slide)
                return

            const index = Array.prototype.indexOf
                .call(slide.parentNode.children, slide)

            if (index > -1 && slider.activeIndex !== index)
                slider.slideTo(index)
        })
})(window, document)
